/* eslint-disable consistent-return */
/* eslint-disable no-useless-return */
/* eslint-disable no-else-return */
// 네이티브 앱과 통신하는 유틸 파일 - 자동로그인

import { deviceOsType } from './constants/deviceOsConstants';
import { storageConstants } from './constants/storageConstants';

// os 분기 함수
const getDeviceOS = () => {
  const os = localStorage.getItem(storageConstants.deviceOS);
  return os ? os.toLowerCase() : null;
};

// 웹에서 로그인시 네이티브 앱으로 로컬데이터 전달
export const callAutoLoginNative = () => {
  const userParams = localStorage.getItem(storageConstants.userParams);
  const brandCode = localStorage.getItem(storageConstants.brandCode);

  const localStorageData = JSON.stringify({
    userParams,
    brandCode,
  });

  const deviceOS = getDeviceOS();
  console.log('[자동로그인-로그인] deviceOS, localStorageData > ', deviceOS, localStorageData);
  if (deviceOS === deviceOsType.ios) {
    console.log('[자동로그인-로그인] 유저데이터 > iOS > ', localStorageData);
    return window.webkit.messageHandlers.callAutoLogin.postMessage(localStorageData);
  } else if (deviceOS === deviceOsType.android) {
    console.log('[자동로그인-로그인] 유저데이터 > 안드로이드 > ', localStorageData);
    return AndroidBridge.callAutoLogin(localStorageData);
  }
};

// 네이티브 로그아웃 처리 함수
export const callAutoLogout = () => {
  const deviceOS = getDeviceOS();
  if (deviceOS === deviceOsType.ios) {
    console.log('[학습자-자동로그인-로그아웃] iOS');
    return window.webkit.messageHandlers.deleteAutoLogin.postMessage('');
    // eslint-disable-next-line no-else-return
  } else if (deviceOS === deviceOsType.android) {
    console.log('[학습자-자동로그인-로그아웃] android');
    return AndroidBridge.deleteAutoLogin();
  }
};

// 웹에서 로그인 시 앱에 저장되어있는 유저 데이터 요청 함수
export const callAutoLoginData = () => {
  const deviceOS = getDeviceOS();
  try {
    if (deviceOS === deviceOsType.ios) {
      console.log('ios 자동 로그인  데이터 호출');
      window.webkit.messageHandlers.callAutoLoginData.postMessage('');
      return;
    } else if (deviceOS === deviceOsType.android) {
      console.log('android 자동 로그인  데이터 호출');
      return AndroidBridge.callAutoLoginData();
    }
  } catch (error) {
    console.log('CALL AUTO LOGIN DATA ERROR : ', error);
  }
};
